import { Component, Inject, Input, OnInit, Optional, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'confirm-input-modal',
    templateUrl: 'confirm-input-modal.html',
    styleUrls: ['confirm-input-modal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalConfirmWithInputComponent implements OnInit {
    @Input() message;
    formGroup;

    constructor(
        fb: UntypedFormBuilder,
        private modal: NzModalRef,
        @Optional() @Inject(NZ_MODAL_DATA) data?: { message?: string }
    ) {
        if (data?.message) {
            this.message = data.message;
        }
        this.formGroup = fb.group({
            reasonId: [],
            note: [],
        });
    }

    ngOnInit() { }

    close() {
        this.modal.destroy();
    }

    ok() {
        this.modal.destroy(this.formGroup.value);
    }
}
